// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR COMPONENTS
import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Badge from 'material-ui/Badge';

// CONSTANTS
import { constants } from '../../constants';

// COMPONENTS
import ServiceCardListOuterContainer from './ServiceCardListOuterContainer';
import ServiceCardListInnerContainer from './ServiceCardListInnerContainer';
import StyledRouteLink from 'components/Assests/StyledRouteLink';
import GhostDiv from 'components/Assests/GhostDiv';
import StyledLink from 'components/StyledLink';
import PercentBarChart from 'components/DataVisualization/PercentBarChart/PercentBarChart';
import ServiceProgress from './ServiceProgress';
import PText from 'components/Primatives/PText';
import ServiceDate from './ServiceDate';
import Button from 'components/Primatives/Button';
import FlexColumn from 'components/Primatives/FlexColumn';
import H1 from 'components/Primatives/H1';
import BackgroundImg from 'components/Primatives/BackgroundImg';
import Strong from 'components/TextModifiers/Strong';
import { FluidSection } from 'components/FluidSection/FluidSection';

class ServiceCardList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gotCount: false,
        };
    }

    componentDidMount() {
        this.props.services.map(service => {
            this.getUnreadCount(service);
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.unreadContentCount !== nextProps.unreadContentCount) {
            this.props.services.map(service => {
                this.getUnreadCount(service);
            });
        }
    }

    getUnreadCount = service => {
        // console.log('GETTING UNREAD COUNT FOR SERVICE:', service._id);
        if (!this.state.gotCount && this.props.selectedClient) {
            // GET UNREADS FOR SERVICE PROVIDER // console.log('GETTING UNREAD NOTIFICATIONS FOR SERVICE PROVIDER');
            this.props.checkUnreadsForServiceConsumerPair(
                this.props.userId,
                this.props.selectedClient.uid,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
        if (!this.state.gotCount && !this.props.selectedClient) {
            // GET UNREADS FOR HEALTH CONSUMER // console.log('GETTING UNREAD NOTIFICATIONS FOR HEALTH CONSUMER');
            this.props.checkUnreadsForService(
                this.props.userId,
                null,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
    };

    getGreyCards = services => {
        let container = (
            <ServiceCardListOuterContainer
                style={{
                    backgroundColor: constants.color.grey34,
                    opacity: 0.1,
                    boxShadow: 'none',
                }}
            />
        );

        if (services.length === 2) {
            return [container];
        }
        if (services.length === 1) {
            return [container, container];
        }
    };

    render() {
        const {
            providers,
            services,
            onServiceSelect,
            header = null,
            divider = null,
            checkUnreadsForUserService,
            servicesData,
        } = this.props;

        return (
            <FluidSection sectionMaxWidth={380} sectionMinWidth={280}>
                {services.map((service, i) => {
                    // GET THE PROVIDER FOR THIS SERVICE
                    const provider = providers.filter(serviceProvider => {
                        if (serviceProvider.uid === service.provider) {
                            return true;
                        }
                    })[0]; // Get provider from array, hence [0]

                    const serviceData = servicesData.filter(serviceData => {
                        // console.log('serviceData', serviceData)
                        if (serviceData._id === service._id) {
                            return true;
                        }
                    })[0]; // Get provider from array, hence [0]
                    // console.log('SLC-service', service)
                    // console.log('SLC-provider', provider)
                    // console.log('SLC-serviceData._id', serviceData._id)
                    // console.log(
                    //     'SLC-service.activePeriods',
                    //     service.activePeriods,
                    // );
                    // console.log('SLC-props', this.props)
                    return (
                        //use url to determin what service is selected
                        <ServiceCardListOuterContainer key={i}>
                            <BackgroundImg
                                backgroundImageURL={serviceData.coverPhotoURL}
                                style={{
                                    // maxWidth: 200,
                                    // width: '30%'
                                    height: 110,
                                    // maxHeight: 200,
                                    width: '100%',
                                }}
                            >
                                {/*
                                        <div style={{ backgroundColor: constants.color.primaryDark, width: '100%', height: '100%', opacity: 0.6 }}/>
                                    */}
                            </BackgroundImg>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    justifyContent: 'space-between',
                                }}
                            >
                                <ServiceCardListInnerContainer>
                                    <div>
                                        {this.props.unreadContentCount &&
                                            this.props.unreadContentCount[
                                                service._id
                                            ] && (
                                                <Badge
                                                    badgeContent={
                                                        this.props
                                                            .unreadContentCount[
                                                            service._id
                                                        ].count
                                                    }
                                                    secondary={true}
                                                    style={{
                                                        display:
                                                            this.props
                                                                .unreadContentCount &&
                                                            this.props
                                                                .unreadContentCount[
                                                                service._id
                                                            ] &&
                                                            this.props
                                                                .unreadContentCount[
                                                                service._id
                                                            ].count
                                                                ? 'block'
                                                                : 'none',
                                                        marginBottom: -20,
                                                        marginRight: -13,
                                                    }}
                                                />
                                            )}
                                        <BackgroundImg
                                            height="100px"
                                            width="100px"
                                            borderRadius={5}
                                            // circle
                                            backgroundImageURL={
                                                provider.profilePhotoURL
                                            }
                                            style={{
                                                marginBottom: 10,
                                                overflow: 'hidden',
                                            }}
                                        />
                                    </div>
                                    <H1 altDark style={{ marginBottom: 0 }}>
                                        <Strong>{service.name}</Strong>
                                    </H1>
                                    <StyledRouteLink
                                        style={{ textDecoration: 'underline' }}
                                        to={`/service/detail/${service._id}`}
                                    >
                                        View Service Details
                                    </StyledRouteLink>
                                    {serviceData &&
                                        serviceData.duration > 1 && (
                                            <ServiceProgress
                                                activePeriods={
                                                    service.activePeriods
                                                }
                                            />
                                        )}
                                    {serviceData &&
                                        serviceData.duration <= 1 && (
                                            <ServiceDate
                                                activePeriods={
                                                    service.activePeriods
                                                }
                                            />
                                        )}
                                    <PText
                                        altColor
                                        style={{
                                            marginBottom: 0,
                                            marginTop: 0,
                                            fontSize: '1.4rem',
                                        }}
                                    >
                                        Provider
                                    </PText>
                                    <FlexColumn>
                                        <StyledRouteLink
                                            style={{
                                                textDecoration: 'underline',
                                                fontSize:
                                                    constants.text
                                                        .baseFontStyles
                                                        .fontSize,
                                            }}
                                            to={`/expert/${provider.uid}`}
                                        >
                                            {`${provider.name.first} ${
                                                provider.name.last
                                            }`}
                                        </StyledRouteLink>
                                        <PText style={{ marginTop: 0 }}>
                                            {provider.expertise}
                                        </PText>
                                    </FlexColumn>
                                </ServiceCardListInnerContainer>

                                <Button
                                    style={{ borderRadius: 0, borderWidth: 0 }}
                                    onClick={() => onServiceSelect(service)}
                                >
                                    View Service
                                </Button>
                            </div>
                        </ServiceCardListOuterContainer>
                    );
                })}
                {services &&
                    services.length > 0 &&
                    services.length < 3 &&
                    this.getGreyCards(services).map((greyCard, i) => (
                        <React.Fragment key={i}>{greyCard}</React.Fragment>
                    ))}
            </FluidSection>
        );
    }
}

const mapStateToProps = ({ notification, auth, service }) => {
    // console.log('NOTIFICATION UNREAD COUNTS @ SERVICE LIST ITEMS', notification.unreadCount);

    return {
        unreadContentCount:
            notification.unreadCount && notification.unreadCount,
        userId: auth.authData.id,
        servicesData: service.services,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(ServiceCardList);



// WEBPACK FOOTER //
// ./src/js/components/ServiceCardList/ServiceCardList.jsx